import classes from 'styles/components/Nav/Divider.module.scss';

const Divider = () => <div className={classes.root} />;

export default Divider;
